// extracted by mini-css-extract-plugin
module.exports = {"empty-state-panel":"CatalogEmptyStates_empty-state-panel__zBxIY","new-catalog-button":"CatalogEmptyStates_new-catalog-button__9XKOV"};